import React, { useState } from "react";
import { useTable, usePagination, useRowSelect } from "react-table";
import activo_icono from "../../../../assets/vw/svg/point-verde.svg";
import inactivo_icono from "../../../../assets/vw/svg/point-rojo.svg";
import double_before from "../../../../assets/vw/svg/double-before.svg";
import before from "../../../../assets/vw/svg/before.svg";
import after from "../../../../assets/vw/svg/after.svg";
import double_after from "../../../../assets/vw/svg/double-after.svg";
import DropDown from "../../../../components/Dropdown";
import SEARCH from "../../../../assets/vw/svg/search.svg";
import menu_opc from "../../../../assets/vw/svg/menu-opciones.svg";
import success_icono from "../../../../assets/vw/svg/check-exito.svg";
import error_icono from "../../../../assets/vw/svg/check-error.svg";
import cerrar from "../../../../assets/vw/svg/cerrar.svg";
import Loading from "../../../../components/Loading";
import unarchive from "../../../../assets/vw/svg/unarchive.svg";
import null_icono from "../../../../assets/vw/svg/null.svg";
import Cards from "../Cards";

const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, ...rest }, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;
    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);
    return (
      <>
        <input
          type="checkbox"
          className="checkbox-round"
          ref={resolvedRef}
          {...rest}
        />
      </>
    );
  }
);

function Table({ columns, data, servicio, marca, handleChange }) {
  const [cargando, setCargando] = useState(false);
  const [limit, setLimit] = useState(10);
  const limitMostrar = ["Mostrar 15", "Mostrar 30", "Mostrar 50", "Todo"];
  const [searchInput, setSearchInput] = useState("");
  const [row, setRow] = useState("");
  const [mostrarModal, setMostrarModal] = useState(false);
  const [mensajeArchivar, setMensajeArchivar] = useState(
    "¿Seguro que quieres desarchivar este rol?"
  );
  const [successArchivar, setSuccessArchivar] = useState(false);
  const [errorArchivar, setErrorArchivar] = useState(false);
  const [showGrid, setShowGrid] = useState(false);
  const [selectGrid, setSelectGrid] = useState([]);

  function searchText(e) {
    setSearchInput(e.target.value);
    handleChange(e);
  }

  const optionLimit = (textoLimit) => {
    switch (textoLimit) {
      case "Mostrar 15":
        return 15;
      case "Mostrar 30":
        return 30;
      case "Mostrar 50":
        return 50;
      case "Todo":
        return data.length;
      default:
        return data.length;
    }
  };

  function activaDesactiva() {
    setCargando(true);
    setMostrarModal(false);
    let arrayRoles = [];
    if (row !== "") {
      arrayRoles.push(row);
    } else if (selectedFlatRows.length > 0) {
      arrayRoles = selectedFlatRows.map((row) => row.original);
    } else if (selectGrid.length > 0) {
      arrayRoles = selectGrid;
    }

    for (let rol of arrayRoles) {
      const nombre = rol.nombre;
      fetch(process.env.REACT_APP_URL_DTO_BACK + "roles", {
        method: "PUT",
        headers: {
          Authorization: "Bearer " + servicio.getToken(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          nombre,
        }),
      })
        .then(async (res) => {
          let responseBody = await res.json();
          if (!res.ok) {
            throw new Error(responseBody.mensaje);
          }
          console.log(responseBody.mensaje);
          setRow("");
          setCargando(false);
          setMensajeArchivar("Los cambios fueron guardados.");
          setSuccessArchivar(true);
          setMostrarModal(true);
        })
        .catch((errorP) => {
          setRow("");
          setCargando(false);
          setMensajeArchivar("Hubo un error al guardar los cambios.");
          setErrorArchivar(true);
          setMostrarModal(true);
        });
    }
  }

  function handleArchivar(e) {
    selectedFlatRows.length < 1 && selectGrid.length < 1
      ? setRow(e.row.original)
      : setRow("");
    setMostrarModal(true);
  }

  function clearModalArchivar() {
    if (successArchivar || errorArchivar) {
      // eslint-disable-next-line no-restricted-globals
      location.reload();
    } else {
      setRow("");
      setMostrarModal(false);
      setMensajeArchivar("¿Seguro que quieres desarchivar este rol?");
      setSuccessArchivar(false);
      setErrorArchivar(false);
    }
  }

  const buildPopUp = () => {
    return (
      <div
        className={`modal modal_vw modal_popup_vw fade ${mostrarModal ? "show" : ""}`}
        id="archivar"
        data-keyboard="false"
        data-backdrop="static"
        tabIndex="-1"
        aria-labelledby="archivarLabel"
        style={mostrarModal ? { display: "block" } : {}}
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal_popup_content">
          <div className="modal-content modal_content-vw">
            <div className="modal-header modal_header-vw">
              <div className="d-flex justify-content-end">
                <button
                  className="button_icon-vw"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={clearModalArchivar}
                >
                  <img src={cerrar} alt="cerrar"></img>
                </button>
              </div>
            </div>
            <div className={`modal-body p-3 p-sm-5 p-lg-5`}>
              {buildContent()}
              {successArchivar || errorArchivar ? "" : buildButtons()}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const buildContent = () => {
    return (
      <>
        {successArchivar ? (
          <div className="mt-0 mt-lg-2 px-2 mensaje_confirmacion mb-0 mb-sm-5">
            <div className="d-flex justify-content-center">
              <img
                src={success_icono}
                className="icono-mensaje"
                alt="exito"
              ></img>
            </div>
            <label className="popup_title popup_title--status d-flex justify-content-center">
              {mensajeArchivar}
            </label>
          </div>
        ) : errorArchivar ? (
          <div className="mt-0 mt-lg-2 px-2 mensaje_confirmacion mb-0 mb-sm-5">
            <div className="d-flex justify-content-center">
              <img
                src={error_icono}
                className="icono-mensaje"
                alt="error"
              ></img>
            </div>
            <label className="popup_title popup_title--status d-flex justify-content-center">
              {mensajeArchivar}
            </label>
          </div>
        ) : (
          <div className="mt-0 mt-lg-2 px-2 mensaje_confirmacion mb-0 mb-sm-5">
            <label className="popup_title d-flex justify-content-center">
              {mensajeArchivar}
            </label>
          </div>
        )}
      </>
    );
  };

  const buildButtons = () => {
    return (
      <div className="d-flex justify-content-center gap-3 mt-3 mt-sm-4 mt-lg-5 mb-3 mb-lg-5">
        <button
          type="button"
          className="button_vw button_vw--secondary"
          data-bs-dismiss="modal"
          onClick={clearModalArchivar}
        >
          Cancelar
        </button>
        <button
          type="button"
          className="button_vw button_vw--primary"
          data-bs-dismiss="modal"
          onClick={activaDesactiva}
        >
          Desarchivar
        </button>
      </div>
    );
  };

  const onChangeGrid = (value) => {
    setShowGrid(value);
    setSelectGrid([]);
    toggleAllRowsSelected(false);
  };
  const selects = (checkObj, tipo) => {
    if (tipo === "push") {
      setSelectGrid([...selectGrid, checkObj]);
    } else if (tipo === "pop") {
      let rol = checkObj.nombre;
      setSelectGrid((l) => l.filter((item) => item.nombre !== rol));
    }
  };

  const gridRol = (page) => {
    const selectCheck = (e, index) => {
      let y = document.getElementById(e.target.id);
      let permiso = page[index].original;
      if (y.checked) {
        selects(permiso, "push");
      } else {
        selects(permiso, "pop");
      }
    };

    return (
      <div className="grid__view row">
        {page.map((tiposObj, index) => {
          return (
            <div className="col-3 mb-3" key={index}>
              <div className="card_grid">
                <div className="d-flex">
                  <div key={"select-" + index} className="ms-auto">
                    <input
                      key={"select-" + index}
                      type="checkbox"
                      className="checkbox-round mx-1"
                      id={"select-" + index}
                      value={tiposObj.original.nombre}
                      onChange={(e) => selectCheck(e, index)}
                    />
                  </div>
                </div>

                <div className="d-flex align-items-start flex-column mx-4 mt-3 size-card">
                  <div className="contenedor_height w-100 d-flex align-items-center justify-content-center">
                    <div className="title_card text-center">
                      {tiposObj.original.nombre.length > 50
                        ? `${tiposObj.original.nombre.substring(0, 50)}…`
                        :tiposObj.original.nombre}</div>
                  </div>
                  <div>
                    <img src={inactivo_icono} alt="inactivo"></img>
                    <div className={` tooltip_vw`}>
                      <img src={menu_opc} alt="menu"></img>
                      <div className="tooltiptext p-2 ">
                        <button
                          className="button_icon-vw"
                          type="button"
                          onClick={() => handleArchivar({ row: tiposObj })}
                        >
                          <div className="aling-icon-desarchivar">
                            {" "}
                            <img
                              src={unarchive}
                              alt="unarchive"
                              className="px-1"
                            ></img>{" "}
                            Desarchivar
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    selectedFlatRows,
    setPageSize,
    state: { pageIndex },
    toggleAllRowsSelected,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 15 },
    },
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        {
          id: "selection",
          Header: ({ getToggleAllPageRowsSelectedProps }) => (
            <div>
              <IndeterminateCheckbox {...getToggleAllPageRowsSelectedProps()} />
            </div>
          ),
          Cell: ({ row }) => (
            <div>
              <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
            </div>
          ),
        },
        ...columns,
      ]);
    }
  );

  const NavigationControl = () => {
    return (
        <div className="btn-group btn-group-controls" role="group" aria-label="First group">
          <button
              onClick={() => gotoPage(0)}
              disabled={!canPreviousPage}
              className={
                "btn btn-secondary btn__secondary-- btn_pagination"
              }
          >
            <img src={double_before} alt="first"/>
          </button>
          {" "}
          <button
              onClick={() => previousPage()}
              disabled={!canPreviousPage}
              className={
                "btn btn-secondary btn__secondary-- btn_pagination"
              }
          >
            <img src={before} alt="before"/>
          </button>
          {" "}
          <div className="num_pagination py-3">
            {pageIndex + 1} de {pageOptions.length}
          </div>
          <button
              onClick={() => nextPage()}
              disabled={!canNextPage}
              className={
                "btn btn-secondary btn__secondary-- btn_pagination"
              }
          >
            <img src={after} alt="after"/>
          </button>
          {" "}
          <button
              onClick={() => gotoPage(pageCount - 1)}
              disabled={!canNextPage}
              className={
                "btn btn-secondary btn__secondary-- btn_pagination"
              }
          >
            <img src={double_after} alt="last"/>
          </button>
          {" "}
        </div>
    );
  }

  return cargando ? (
      <Loading/>
  ) : (
      <>
        <div className="content main-content-container">
          <div className="main-content-actions row m-0 py-2">
              <div className="col-7 col-sm-6 col-lg-3 wrapper m-0 p-0 ">
                  <input
                      className="input_vw"
                      name="searchInput"
                      value={searchInput || ""}
                      onChange={(e) => {
                          searchText(e);
                      }}
                      placeholder="Busca por ID, nombre, número…."
                  />
                  <span className="pt-2 ps-1">
                      <img src={SEARCH} alt="buscar" className="icono-menu me-3"/>
                  </span>
              </div>

              <div className="d-flex col-1 col-sm-1 col-lg-3">
                  {selectedFlatRows.length > 0 || selectGrid.length > 0 ? (
                      <button
                          type="button"
                          className={"button_vw button_vw--archivo-azul button_unarchive_item"}
                          onClick={handleArchivar}
                      >
                          <div className={"unarchive-icon"}></div>
                          <span className={"ml-2"}>Desarchivar</span>
                      </button>
                  ) : (
                      ""
                  )}
              </div>

              <div className="col-3 col-sm-5 col-lg-6 p-0">
                  <div className="d-flex justify-content-end align-items-center">
                      <div
                          className={`view_select_all ${showGrid ? 'icon_grid_active' : ''} ms-auto align-self-center`}>
                          <input
                              type="checkbox"
                              className="checkbox-round mx-1"
                              id={"1"}
                              value={0}
                              onChange={() => {
                              }}
                          />
                      </div>
                      <div className="view__options">
                          <button
                              className="button_icon-vw kit_icon"
                              type="button"
                              onClick={() => onChangeGrid(true)}
                          >
                  <span
                      className={`${showGrid ? "icon-grid-active" : "icon-grid"}`}
                  >
                    {" "}
                  </span>
                          </button>
                          <button
                              className="button_icon-vw kit_icon"
                              type="button"
                              onClick={() => onChangeGrid(false)}
                          >
                  <span
                      className={`${
                          !showGrid ? "icon-table-active" : "icon-table"
                      }`}
                  >
                    {" "}
                  </span>
                          </button>
                      </div>
                      <div className="">
                          <DropDown
                              menu={limitMostrar}
                              title={limitMostrar[0]}
                              inputField={limit}
                              handleOptionSelected={(e) => {
                                  const limitInt = optionLimit(e);
                                  setLimit(limitInt);
                                  setPageSize(Number(limitInt));
                              }}
                          />
                      </div>
                      <NavigationControl/>
                  </div>
              </div>
          </div>
        </div>

          <Cards
              page={page}
              rowDesarchivar={handleArchivar}
              selects={selects}
              NavigationControl={NavigationControl}
              archivo={true}
          />

          {showGrid ? (
              gridRol(page)
          ) : (
            <div 
            className="table-responsive"
            style={{
              overflowY: 'hidden'
            }}
          >
              <table
                  {...getTableProps()}
                  className="table table-striped table-responsive tabla_contenido_vw"
      >
        <thead className="thead-dark">
          {headerGroups.map((headerGroup) => (
            <tr
              {...headerGroup.getHeaderGroupProps()}
              className="thead__titulo"
            >
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()} className="tbody-table">
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell, cellId) => {
                  if (cell.column.id !== "selection" && (cell.value === undefined || cell.value === "") ) {
                    return (
                      <td key={cellId}><img src={null_icono} alt="sinsoporte"></img></td>
                    );
                  }
                  if (cell.column.Header === "Activo") {
                    if (cell.value === 1) {
                      return (
                        <td
                          className="contenido_boolean"
                          {...cell.getCellProps()}
                        >
                          <div className="d-flex">
                            <div className="flex-grow-1">
                              <img src={activo_icono} alt="activo"></img>
                            </div>
                            <div className={`tooltip_vw`}>
                              <img src={menu_opc} alt="menu"></img>
                              <div className="tooltiptext p-2 ">
                                <button
                                  className="button_icon-vw p-0"
                                  type="button"
                                  onClick={() => handleArchivar(cell)}
                                >
                                  <div className="aling-icon-desarchivar">
                                    {" "}
                                    <img
                                      src={unarchive}
                                      alt="unarchive"
                                      className="px-1"
                                    ></img>{" "}
                                    Desarchivar
                                  </div>
                                </button>
                              </div>
                            </div>
                          </div>
                        </td>
                      );
                    } else
                      return (
                        <td
                          className="contenido_boolean"
                          {...cell.getCellProps()}
                        >
                          <div className="d-flex">
                            <div className="flex-grow-1">
                              <img src={inactivo_icono} alt="inactivo"></img>
                            </div>
                            <div className={` tooltip_vw`}>
                              <img src={menu_opc} alt="menu"></img>
                              <div className="tooltiptext p-2 ">
                                <button
                                  className="button_icon-vw p-0"
                                  type="button"
                                  onClick={() => handleArchivar(cell)}
                                >
                                  <div className="aling-icon-desarchivar">
                                    {" "}
                                    <img
                                      src={unarchive}
                                      alt="unarchive"
                                      className="px-1"
                                    ></img>{" "}
                                    Desarchivar
                                  </div>
                                </button>
                              </div>
                            </div>
                          </div>
                        </td>
                      );
                  }

                  return (
                    <td className="contenido_boolean" {...cell.getCellProps()}>
                      {cell.render("Cell")}{" "}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
      </div>
      )}
      {buildPopUp()}
    </>
  );
}

function Tabla(props) {
  const columns = React.useMemo(
    () => [
      {
        Header: "Nombre",
        accessor: "nombre",
      },
      {
        Header: "Activo",
        accessor: "activo",
      },
      /* {
             Header: 'Fecha',
             accessor: 'fechaCreacion',
             Cell: props => <div> {new Date(props.value).toLocaleString("es-MX", { year: 'numeric', month: 'numeric', day: 'numeric' })} </div>
           }*/
    ],
    []
  );
  return (
    <>
      <Table
        columns={columns}
        data={props.roles}
        servicio={props.servicio}
        marca={props.marca}
        nombreMarca={props.marcaNombre}
        handleChange={props.handleChange}
      />
    </>
  );
}

export default Tabla;
